import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MyFundiService } from '../../../services/myFundiService';

@Component({
  selector: 'fundi-role',
    templateUrl: './fundi.component.html'
})
export class FundiRoleComponent {
}

